import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "tabUrl", "tabText", "tabManual",
    "panelUrl", "panelText", "panelManual",
    "form", "ingredientsContainer", "stepsContainer",
    "ingredientTemplate", "stepTemplate"
  ]

  connect() {
    if (this.hasIngredientsContainerTarget) {
      this.ingredientIndex = this.ingredientsContainerTarget.querySelectorAll(".ingredient-row").length
    }
    if (this.hasStepsContainerTarget) {
      this.stepIndex = this.stepsContainerTarget.querySelectorAll(".step-row").length
      this.updateStepNumbers()
    }
  }

  showTab(event) {
    const tab = event.currentTarget.dataset.tab

    if (this.hasTabUrlTarget) {
      this.tabUrlTarget.classList.remove("bg-terracotta", "text-cream")
      this.tabUrlTarget.classList.add("bg-transparent", "text-cream/60")
    }
    if (this.hasTabTextTarget) {
      this.tabTextTarget.classList.remove("bg-terracotta", "text-cream")
      this.tabTextTarget.classList.add("bg-transparent", "text-cream/60")
    }
    if (this.hasTabManualTarget) {
      this.tabManualTarget.classList.remove("bg-terracotta", "text-cream")
      this.tabManualTarget.classList.add("bg-transparent", "text-cream/60")
    }

    if (this.hasPanelUrlTarget) this.panelUrlTarget.classList.add("hidden")
    if (this.hasPanelTextTarget) this.panelTextTarget.classList.add("hidden")

    if (tab === "url") {
      if (this.hasTabUrlTarget) {
        this.tabUrlTarget.classList.remove("bg-transparent", "text-cream/60")
        this.tabUrlTarget.classList.add("bg-terracotta", "text-cream")
      }
      if (this.hasPanelUrlTarget) this.panelUrlTarget.classList.remove("hidden")
      if (this.hasPanelManualTarget) this.panelManualTarget.classList.add("hidden")
    } else if (tab === "text") {
      if (this.hasTabTextTarget) {
        this.tabTextTarget.classList.remove("bg-transparent", "text-cream/60")
        this.tabTextTarget.classList.add("bg-terracotta", "text-cream")
      }
      if (this.hasPanelTextTarget) this.panelTextTarget.classList.remove("hidden")
      if (this.hasPanelManualTarget) this.panelManualTarget.classList.add("hidden")
    } else {
      if (this.hasTabManualTarget) {
        this.tabManualTarget.classList.remove("bg-transparent", "text-cream/60")
        this.tabManualTarget.classList.add("bg-terracotta", "text-cream")
      }
      if (this.hasPanelManualTarget) this.panelManualTarget.classList.remove("hidden")
    }
  }

  showManualPanel() {
    this.panelManualTarget.classList.remove("hidden")
  }

  addIngredient() {
    const template = this.ingredientTemplateTarget.innerHTML
    const newRow = template.replace(/NEW_RECORD/g, Date.now())
    this.ingredientsContainerTarget.insertAdjacentHTML("beforeend", newRow)
    this.ingredientIndex++
    this.updatePositions()
  }

  addStep() {
    const template = this.stepTemplateTarget.innerHTML
    const newRow = template.replace(/NEW_RECORD/g, Date.now())
    this.stepsContainerTarget.insertAdjacentHTML("beforeend", newRow)
    this.stepIndex++
    this.updateStepNumbers()
    this.updatePositions()
  }

  removeRow(event) {
    const row = event.currentTarget.closest(".ingredient-row, .step-row")
    const destroyField = row.querySelector(".destroy-field")

    if (destroyField) {
      destroyField.value = "true"
      row.classList.add("hidden")
    } else {
      row.remove()
    }

    this.updateStepNumbers()
    this.updatePositions()
  }

  updateStepNumbers() {
    const visibleSteps = this.stepsContainerTarget.querySelectorAll(".step-row:not(.hidden)")
    visibleSteps.forEach((row, index) => {
      const numberEl = row.querySelector(".step-number")
      if (numberEl) {
        numberEl.textContent = index + 1
      }
    })
  }

  updatePositions() {
    const ingredientRows = this.ingredientsContainerTarget.querySelectorAll(".ingredient-row:not(.hidden)")
    ingredientRows.forEach((row, index) => {
      const positionField = row.querySelector("input[name*='[position]']")
      if (positionField) positionField.value = index
    })

    const stepRows = this.stepsContainerTarget.querySelectorAll(".step-row:not(.hidden)")
    stepRows.forEach((row, index) => {
      const positionField = row.querySelector("input[name*='[position]']")
      if (positionField) positionField.value = index
    })
  }
}
